 function func(event) {
          if (event.value === "View All") {
            event.value = "View Less";
          } else {
            event.value = "View All";
          }
        }